export default {
  root: {
    backgroundColor: 'rgb(242 242 242 / 50%)',
    borderTopLeftRadius: '0',
    borderTopRightRadius: '0',
  },
}
